import { HttpAction } from "@megaron/http-service";
import { Serializers, SerializerValue } from "@megaron/serializers";
import { uuidSerializer } from "@megaron/uuid";

export const accountHistoryEntrySerializer = Serializers.first(
  Serializers.object({
    type: Serializers.stringOneOf("productCodeRedeemed"),
    customerUuid: uuidSerializer,
    time: Serializers.datetime,
    productId: Serializers.string,
    transactionUuid: uuidSerializer,
    massKg: Serializers.decimal,
    redeemedAt: Serializers.datetime,
  }),
  Serializers.object({
    type: Serializers.stringOneOf("rewardPurchased"),
    customerUuid: uuidSerializer,
    time: Serializers.datetime,
    rewardId: Serializers.string,
    purchaseUuid: uuidSerializer,
    price: Serializers.decimal,
  }),
  Serializers.object({
    type: Serializers.stringOneOf("proStatusEarned"),
    customerUuid: uuidSerializer,
    time: Serializers.datetime,
  }),
  Serializers.object({
    type: Serializers.stringOneOf("affiliateCodeClaimed"),
    customerUuid: uuidSerializer,
    time: Serializers.datetime,
  }),
  Serializers.object({
    type: Serializers.stringOneOf("affiliateCodeRedeemed"),
    customerUuid: uuidSerializer,
    time: Serializers.datetime,
    transactionUuid: uuidSerializer,
    invitedByUuid: uuidSerializer.nullable(),
    salespersonEmail: Serializers.string.nullable(),
    region: Serializers.string.nullable(),
    codeId: Serializers.string,
  }),
  Serializers.object({
    type: Serializers.stringOneOf("userInvited"),
    customerUuid: uuidSerializer,
    time: Serializers.datetime,
    invitedUserUuid: uuidSerializer,
    codeId: Serializers.string,
  }),
);

export type AccountHistoryEntry = SerializerValue<typeof accountHistoryEntrySerializer>;

export const accountHistoryQuery = HttpAction({
  path: "/accounts/events",
  method: "get",
  requiresAuth: true as const,
  qsSerializer: Serializers.object({
    uuids: uuidSerializer.array().asJsonString(),
  }).partial(),
  valueSerializer: Serializers.array(accountHistoryEntrySerializer),
  errorSerializer: Serializers.stringOneOf(),
});
